import { ConfirmDialog, Typography } from '@occc-app/design-system';

type ReSubmitExistingFileDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  franchiseName: string;
  isSubmitting?: boolean;
};

export const ReSubmitExistingFileDialog = ({
  open,
  onClose,
  onConfirm,
  franchiseName,
  isSubmitting = false,
}: ReSubmitExistingFileDialogProps) => (
  <ConfirmDialog
    open={open}
    onClose={onClose}
    confirmButtonText='Accept'
    declineButtonText='Cancel'
    confirmButtonProps={{
      onClick: onConfirm,
      loading: isSubmitting,
      disabled: isSubmitting,
    }}
    declineButtonProps={{
      disabled: isSubmitting,
    }}
  >
    <Typography>
      <Typography variant={'subtitle1'} component='span'>
        Warning:
      </Typography>{' '}
      Are you sure you want to resubmit an existing file for{' '}
      <Typography variant={'subtitle1'} component='span'>
        {franchiseName}
      </Typography>
      ?
    </Typography>
  </ConfirmDialog>
);
